import React, { Component } from 'react';
import { connect } from 'react-redux';
import { get_attendance_list } from '../actions/index';
import '../global';

class AttendanceList extends Component {

	componentDidMount() {
		this.interval = setInterval( () => this.setState( { time: Date.now() } ), 5000 );
	}

	componentWillUnmount() {
		clearInterval( this.interval );
	}

	generateAttendanceList() {
		let attendanceList = this.props.attendance_list;
		if ( typeof attendanceList[ 'time' ] !== 'undefined' ) {
			delete attendanceList[ 'time' ];
		}
		let attendanceHTML = attendanceList.map( firm => {
			return (<div className="firm-row" key={firm.id}>{ firm.company_name }
					<i className="glyphicon glyphicon-ok firm-confirmed"></i></div>
			);
		} );
		return attendanceHTML;
	}

	render() {
		if ( this.props.expired_token === true ) {
			clearInterval( this.interval );
			return (<div className="bg-success">
				The roll call has now ended. Thank you for attending the meeting. Please contact the
				<a href={ 'mailto:' + getContactEmail() }> ISDA Staff Contact</a> for any additional questions.
			</div>
			);
		}
		if ( typeof this.props.attendance_list[ 'time' ] === 'undefined' ) {
			this.props.get_attendance_list();
		} else if ( Date.now() > this.props.attendance_list[ 'time' ] ) {
			this.props.get_attendance_list();
		}
		return (
			<div className="attendance-list">
				<span className="roll-call-success-message">You are included in the roll call.<i className="glyphicon glyphicon-ok" /></span>
				<div className="firms-attending-container">
					<span>{ this.props.attendance_list.length } firm(s) in attendance</span>
				</div>
				{ this.generateAttendanceList() }
			</div>
		);
	}

}

function mapStateToProps( { attendance_list, expired_token } ) {
	return { attendance_list , expired_token};
}

export default connect( mapStateToProps, { get_attendance_list } )( AttendanceList );